var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.9206 50.4022C59.6176 46.8235 55.6094 43.9675 51.1483 42.0141C46.6873 40.0608 41.87 39.0523 37.0001 39.0523C32.1301 39.0523 27.3128 40.0608 22.8518 42.0141C18.3907 43.9675 14.3825 46.8235 11.0795 50.4022C10.5695 50.966 10.2843 51.6975 10.2778 52.4577V64.7911C10.2886 65.6017 10.6183 66.3754 11.1953 66.9448C11.7724 67.5141 12.5505 67.8333 13.3612 67.8333H60.6389C61.4567 67.8333 62.241 67.5084 62.8192 66.9302C63.3974 66.352 63.7223 65.5677 63.7223 64.7499V52.4166C63.7059 51.6706 63.4213 50.9555 62.9206 50.4022Z",
    fill: "#AAAAAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37 34.9445C44.9467 34.9445 51.3889 28.5023 51.3889 20.5556C51.3889 12.6088 44.9467 6.16669 37 6.16669C29.0532 6.16669 22.6111 12.6088 22.6111 20.5556C22.6111 28.5023 29.0532 34.9445 37 34.9445Z",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarIcon);
export default __webpack_public_path__ + "static/media/avatar-icon.2319c6115ccde27541ed849e42413700.svg";
export { ForwardRef as ReactComponent };